/* eslint-disable spire/export-styles */
import withDynamicGoogleMaps, { HasDynamicGoogleMaps } from "@insite/client-framework/Common/withDynamicGoogleMaps";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import updatePickUpWarehouse from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import handleBranchSelection from "@WhiteCap/Handlers/BranchSelection/HandleBranchSelection";
import * as React from "react";
import { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        settings: getSettingsCollection(state),
        session: state.context.session,
    }
}

const mapDispatchToProps = {
    handleBranchSelection,
    updatePickUpWarehouse
}

type Props =
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasDynamicGoogleMaps;

const LocationHelper = ({ useLoadScript, settings, handleBranchSelection, updatePickUpWarehouse, session }: Props) => {
    const { googleMapsApiKey } = settings.websiteSettings;
    const { isLoaded } = useLoadScript({ googleMapsApiKey });

    const alreadySelectedBranch = localStorage.getItem("selectedShipBranch");
    const toasterContext = React.useContext(ToasterContext);

    useEffect(() => {
        if (!isLoaded) {
            return;
        }

        if (session?.properties?.defaultWarehouse && session?.properties?.defaultWarehouse !== "") {
            if (session?.pickUpWarehouse?.id !== undefined) {
                localStorage.setItem("selectedShipBranch", JSON.stringify(session?.pickUpWarehouse));
            }
            return;
        }

        if (alreadySelectedBranch !== null && alreadySelectedBranch !== "") {
            const alreadySelectedBranchModel: WarehouseModel = JSON.parse(alreadySelectedBranch);

            if (alreadySelectedBranchModel && alreadySelectedBranchModel?.id === session?.pickUpWarehouse?.id) {
                return
            }
            setPreviousBranchAsCurrentBranch(alreadySelectedBranchModel);
            return;
        }

        const getLocation = () => {
            if (!navigator.geolocation) {
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    getNearestWarehouse(latitude, longitude);
                },
                (err) => {
                    // no action needed here.
                }
            );
        };

        getLocation();
    }, [isLoaded]);

    const getNearestWarehouse = (latitude: number, longitude: number) => {
        handleBranchSelection({
            latitude, longitude, onSuccess: (result => {
                if (result && result?.nearestBranch !== undefined) {
                    if (session.pickUpWarehouse?.id === result?.nearestBranch?.id) {
                        return;
                    }
                    const isAutoChangeProperty = { "isAutoChange": "true" }
                    updatePickUpWarehouse({
                        pickUpWarehouse: {
                            ...result.nearestBranch,
                            properties: isAutoChangeProperty
                        },
                        onSuccess: (result => {
                            toasterContext.addToast({
                                body: siteMessage("geoLocation_Updated_To_Nearby_Branch",),
                                messageType: "success",
                            });
                        })
                    })
                }
                else {
                    toasterContext.addToast({
                        body: siteMessage("geoLocation_No_Nearby_Branch_Found"),
                        messageType: "info",
                    });
                }
            })
        })
    }

    const setPreviousBranchAsCurrentBranch = (alreadySelectedBranch: WarehouseModel) => {
        updatePickUpWarehouse({
            pickUpWarehouse: alreadySelectedBranch,
            onSuccess: (result => {
                toasterContext.addToast({
                    body: siteMessage("geoLocation_Updated_Previously_Selected_Branch"),
                    messageType: "success",
                });
            })
        })
    }

    return <></>
};

export default connect(mapStateToProps, mapDispatchToProps)(withDynamicGoogleMaps(LocationHelper));




